import React from "react";
import CampusLifeFormPage from "../components/campus-life/CampusLifeFormPage";

const CampusLifeEdit = () => <CampusLifeFormPage mode="edit" />;

export default CampusLifeEdit;
